import {
  AutomationProjectionsPayload,
  automationProjectionsPayloadSchema,
  AutomationProjectionsQuery,
  automationProjectionsQuerySchema,
  automationProjectionsSchema,
} from '../models';

export const automationProjections = (
  queueId: number,
  payload: AutomationProjectionsPayload,
  query: AutomationProjectionsQuery
) => {
  return {
    endpoint: `/queues/${queueId}/automation/projections`,
    method: 'POST',
    payload,
    payloadSchema: automationProjectionsPayloadSchema,
    responseSchema: automationProjectionsSchema,
    querySchema: automationProjectionsQuerySchema,
    query,
  } as const;
};
